import { render } from "./Hint.vue?vue&type=template&id=35c2f326&scoped=true"
import script from "./Hint.vue?vue&type=script&lang=js"
export * from "./Hint.vue?vue&type=script&lang=js"

import "./Hint.vue?vue&type=style&index=0&id=35c2f326&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c2f326"]])

export default __exports__